// Query schema of POST /api/admin/replay. Lives in src/shared so the future admin client shares it.
import { z } from 'zod'

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Datum im Format JJJJ-MM-TT erwartet')

export const replayQuerySchema = z.object({
  tenant: z.string().min(1, 'Auftraggeber fehlt'),
  from: isoDate.optional(),
  to: isoDate.optional(),
})

export type ReplayQuery = z.infer<typeof replayQuerySchema>
